import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Autocomplete from '@deprecated-ui/common/Autocomplete';
import Tag from '@deprecated-ui/common/Tag';
import Input from '@deprecated-ui/common/Input';
import earningsSlice, {
  earningsEffects,
  earningsSelectors,
} from 'features/earnings/slice';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DATA_CY from 'constants/data-cy';

const { Tag: CompanyTag } = Tag;

const generateSymbolSearchHandler = (company = []) =>
  company.map(({ name, desc }) => ({
    value: name,
    label: (
      <Flex align="center">
        <CompanyTag size="xs" type="grey">
          {name}
        </CompanyTag>
        {/* @ts-expect-error */}
        <Text weight="400px" size="14px" ml="8px">
          {desc}
        </Text>
      </Flex>
    ),
  }));

const SymbolSearch = () => {
  const [inputSymbol, setInputSymbol] = useState<string>('');
  const delayTimer = useRef(undefined);
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState<boolean>(false);

  const {
    suggestedCompanies,
    earnings: {
      data: { order, sortcol, year, quarter, filter },
    },
  } = useSelector(earningsSelectors);
  const {
    data: { company },
  } = suggestedCompanies;

  const options = generateSymbolSearchHandler(company);

  const getData = (symbol: string = undefined) => {
    dispatch(
      earningsEffects.getEarnings({
        companySymbol: symbol,
        page: '1',
        order: order || 'asc',
        sortcol,
        quarter,
        year,
        filter,
      }),
    );
  };

  const onClickHandler = (symbol) => {
    getData(symbol);
  };

  const onTypeHandler = (e) => {
    const { value } = e.target;

    if (value.length === 0) {
      dispatch(earningsSlice.actions.clearSuggestionCompany());
    }

    setInputSymbol(value);
  };

  // Could be on press enter or on click search
  const onEnterSearch = (e: any) => {
    let inputValue = e;
    if (typeof e !== 'string') {
      inputValue = e.target.value;
    }

    getData(inputValue || undefined);
  };

  useEffect(() => {
    if (!loaded) {
      setLoaded(true);
    }

    return () => {
      setLoaded(false);
    };
  }, []);

  useEffect(() => {
    if (loaded) {
      if (inputSymbol.length !== 0) {
        clearTimeout(delayTimer.current);
        delayTimer.current = setTimeout(() => {
          dispatch(
            earningsEffects.getsuggestedCompanies({ query: inputSymbol }),
          );
        }, 350);
      }
    }
  }, [inputSymbol, dispatch]);

  useEffect(() => {
    if (loaded) {
      const searchButton = document?.querySelector(
        '.sector-search.symbol-search button.ant-input-search-button',
      );

      if (searchButton) {
        searchButton.setAttribute(
          'data-cy',
          DATA_CY.EARNINGS.SEARCH_SYMBOL_BUTTON,
        );
      }
    }
  }, [loaded]);

  return (
    <Autocomplete
      id="symbol-earnings"
      className="sector-search symbol-search"
      options={options}
      onSelect={onClickHandler}
      placeholder="Symbol"
      width="50%"
    >
      <Input.Search
        value={inputSymbol}
        onChange={onTypeHandler}
        onPressEnter={onEnterSearch}
        onSearch={onEnterSearch}
        data-cy={DATA_CY.EARNINGS.SEARCH_SYMBOL_INPUT}
      />
    </Autocomplete>
  );
};

export default SymbolSearch;
